import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHomeServiceMonthlyList } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}
export const fetchHomeServiceMonthlyList = createAsyncThunk(
  'homeServiceMonthlyList/fetchHomeServiceMonthlyList',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getHomeServiceMonthlyList(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取到家月度列表失败');
    }
  }
)
const homeServiceMonthlyListSlice = createSlice({
  name: 'homeServiceMonthlyList',
  initialState: defaultState,
  reducers: {
    resetHomeServiceMonthlyListState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeServiceMonthlyList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchHomeServiceMonthlyList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchHomeServiceMonthlyList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})
export const { resetHomeServiceMonthlyListState } = homeServiceMonthlyListSlice.actions;
export default homeServiceMonthlyListSlice.reducer;